
import { Route, Routes } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import * as PATHS from './CONSTANTS'
import Login from '../pages/auth/login/index'
import BasicProfile from '../pages/basicDetails/index';
import Verification from '../pages/auth/verification';
import DashBoard from '../pages/dashBoard/pages/home/dashBoard';
import ForgotPassword from '../pages/auth/forgotPassword'
import ResetPassword from '../pages/auth/resetPassword';
import ErrorPage from '../pages/error';
import SubmitVerification from '../pages/auth/submitVerification'
import AppliedJobs from '../pages/dashBoard/pages/aplliedJobs';
import Assessments from '../pages/dashBoard/pages/assesments/index';
import Jobs from '../pages/dashBoard/pages/jobs/jobs';
import MyProfile from '../pages/dashBoard/pages/myProfile/index';
import MyRatings from '../pages/dashBoard/pages/myRatings';
import Help from '../pages/dashBoard/pages/help/help';
import JobDetails from '../pages/dashBoard/pages/home/JobDetails';
import Settings from '../pages/dashBoard/pages/settings/settings';
import NonVerifiedDashboard from '../pages/dashBoardOld/dashBoard';
import ResumeShare from '../pages/resumeShare'
import Timesheet from '../pages/dashBoard/pages/timesheet/index';
import AddTimesheet from '../pages/dashBoard/pages/timesheet/addTimesheet';
import SubmitTimesheet from '../pages/dashBoard/pages/timesheet/submitTimesheet'
import Survey from '../pages/Questionire';
import MyContracts from '../pages/dashBoard/pages/mycontracts';
import InvoiceGenerator from '../pages/dashBoard/pages/timesheet/invoiceGenerator';
import ContractSignin from '../pages/dashBoard/pages/contractSignin'
import ReferAndEarn from '../pages/dashBoard/pages/referandearn';
import ReferAndEarnDetails from '../pages/dashBoard/pages/referandearn/referandearndetails';
import ReferAndEarnProfile from '../pages/dashBoard/pages/referandearn/referandearnprofile';
import FallbackPage from '../pages/fallbackPage';

const Signup = lazy(() => import("../pages/auth/signup"))
const renderLoader = () => <p>Loading</p>;

const RouterConfig = () => {
    return (

        <Suspense fallback={renderLoader()}>
            <Routes>
                <Route path={PATHS.SIGNUP1} element={<Signup />} />
                <Route path={PATHS.SIGNUP} element={<Signup />} />
                <Route path={PATHS.LOGIN} element={<Login />} />
                <Route path={PATHS.BASICPROFILE} element={<BasicProfile />} />
                <Route path={PATHS.VERIFICATION} element={<Verification />} />
                <Route path={PATHS.DASHBOARD} element={<DashBoard />} />
                <Route path={PATHS.APPLIEDJOBS} element={<AppliedJobs />} />
                <Route path={PATHS.ASSESSMENTS} element={<Assessments />} />
                <Route path={PATHS.JOBS} element={<Jobs />} />
                <Route path={PATHS.JOBDETAILS} element={<JobDetails />} />
                <Route path={PATHS.MYPROFILE} element={<MyProfile />} />
                <Route path={PATHS.MYRATING} element={<MyRatings />} />
                <Route path={PATHS.HELP} element={<Help />} />
                <Route path={PATHS.SETTINGS} element={<Settings />} />
                <Route path={PATHS.FORGOTPASSWORD} element={<ForgotPassword />} />
                <Route path={PATHS.RESETPASSWORD} element={<ResetPassword />} />
                <Route path={PATHS.ERRORPAGE} element={<ErrorPage />} />
                <Route path={PATHS.SUBMITVERIFICATION} element={<SubmitVerification />} />
                <Route path={PATHS.NONVERIFIEDDASHBOARD} element={<NonVerifiedDashboard />} />
                <Route path={PATHS.RESUMESHARE} element={<ResumeShare />} />
                <Route path={PATHS.TIMESHEET} element={<Timesheet />} />
                <Route path={PATHS.ADDTIMESHEET} element={<AddTimesheet />} />
                <Route path={PATHS.SUBMITTIMESHEET} element={<SubmitTimesheet />} />
                <Route path={PATHS.SURVEY} element={<Survey />} />
                <Route path={PATHS.MYCONTRACTS} element={<MyContracts />} />
                <Route path={PATHS.INVOICEGENERATOR} element={<InvoiceGenerator />} />
                <Route path={PATHS.CONTRACTSIGNIN} element={<ContractSignin />} />
                <Route path={PATHS.REFERANDEARN} element={<ReferAndEarn />} />
                <Route path={PATHS.REFERANDEARNDETAILS} element={<ReferAndEarnDetails />} />
                <Route path={PATHS.REFERANDEARNPROFILE} element={<ReferAndEarnProfile />} />
                <Route path={PATHS.FALLBACKPAGE} element={<FallbackPage/>} />
            </Routes>
        </Suspense>

        // </Routes>
    )
}

export default RouterConfig